import { IconButton } from "@/components/atoms/IconButton/IconButton";
import { classNames } from "@/utility/jsx";
import type React from "react";
import styles from "./LocationSearch.module.scss";

type TabButtonProps = {
  active?: boolean;
  icon?: string;
  svgIcon?: React.ReactNode;
  label: React.ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  disabled?: boolean;
  "data-testid"?: string;
};

export const TabButton: React.FC<TabButtonProps> = ({
  active,
  icon,
  svgIcon,
  label,
  onClick,
  ariaLabel,
  disabled,
  "data-testid": testId,
}) => {
  const resolvedAriaLabel =
    ariaLabel ?? (typeof label === "string" ? label : undefined) ?? (typeof icon === "string" ? icon : "tab");

  return (
    <IconButton
      iconName={icon}
      svgIcon={svgIcon}
      ariaLabel={resolvedAriaLabel}
      isActive={active}
      className={classNames(styles.tab, active ? styles["tab-active"] : styles["tab-inactive"])}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    >
      <span className={styles["tab-label"]}>{label}</span>
    </IconButton>
  );
};
